import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UtilService } from './util.service';
import { MovieService } from './movie.service';
import { Category,  Seriesdb ,Series} from './dexiedb/seriesdb.service';
import Dexie from 'dexie';


@Injectable({
  providedIn: 'root'
})
export class SeriesService {

  domain: any = '';
  username: any = '';
  password: any = '';
  url: any = '';

  Xurl: any;
  Ourl:any;
  OToken:any;

  constructor(public http: HttpClient, public utilService: UtilService,private postAPIService:MovieService) {    
    this.Ourl = this.utilService.getOneStreamUrl();
    this.OToken = this.utilService.getOneStreamToken();
  }
  
  getDataLcal() {
    this.Xurl = this.utilService.getXstreamUrl();
    if (this.Xurl) {
      this.domain = this.utilService.getXstreamUrl();
      this.username = this.utilService.getXstreamUsername();
      this.password = this.utilService.getXstreamPassword();
    }else if(this.Ourl){
      this.domain = this.utilService.getOneStreamUrl();
    }
    else {
      this.domain = this.utilService.getFullUrl();
      this.username = this.utilService.getFullUsername();
      this.password = this.utilService.getFullPassword();
    }
    if(this.Ourl){
      this.url = this.domain + '/play/b2c/v1/';
      return this.url;
    }else{
      this.url = this.domain + '/player_api.php?username=' + this.username + '&password=' + this.password + '&action=';
      return this.url;
    }
  }

  getRequestType(): 'get' | 'post' {
    return (localStorage.getItem('API') as 'get' | 'post') || 'get';
  }

  // dexieDB 
   async loadCategories(): Promise<Category[]> {
      const count = await Seriesdb.categories.count();
    
      if (count === 0) {
        let categories: Category[] = [];
    
        if (this.OToken) {
          categories = await this.http
            .get<Category[]>( this.getDataLcal() + `categories/series?token=${this.OToken}`)
            .toPromise();
        } else {
          const reqType = this.getRequestType();
          if (reqType === 'post') {
            categories = await 
              this.postAPIService.postApi('get_series_categories')
              .toPromise();
          } else {
            categories = await this.http
              .get<Category[]>(this.getDataLcal() + 'get_series_categories')
              .toPromise();
          }
        }
        await Seriesdb.categories.bulkPut(categories);
      }
      return await Seriesdb.categories.toArray();
    }

    
      async loadSeries(): Promise<number> {
        const countBefore = await Seriesdb.series.count();
      
        if (countBefore === 0) {
          const MoviesRaw: any[] = await this.selectedCategoryWiseSeriesLists().toPromise();
          console.log('📺 Fetched total live seris streams:', MoviesRaw.length);
      
          const mappedSeries: Series[] = MoviesRaw.map(m => ({
          name: m.name,
          series_id: m.series_id,
          category_id: m.category_id,
          cover:m.cover,
          }));
      
          // Use bulkPut to avoid duplicate key issues
          await Seriesdb.series.bulkPut(mappedSeries);
      
          const countAfter = await Seriesdb.series.count();
          console.log('💾 Stored Series  in IndexedDB:', countAfter);
          return countAfter;
        } else {
          console.log('💾 IndexedDB already has Series:', countBefore);
          return countBefore;
        }
      }
    async getAllSeries(page: number, limit: number): Promise<Series[]> {
      const offset = (page - 1) * limit;
      return await Seriesdb.series
        .toCollection()        // grab the entire table
        .offset(offset)
        .limit(limit)
        .toArray();
      }
      async getAllSeriesSearch(): Promise<Series[]> {
      return await Seriesdb.series.toArray();
      }

      async getSeriesByCategory(
          categoryId: string,
          page = 1,
          limit = 50
        ): Promise<Series[]> {
          const offset = (page - 1) * limit;
        
          let collection: Dexie.Collection<Series, any>;
          if (categoryId === 'all') {
            // no where-clause → all movies
            collection = Seriesdb.series.orderBy('category_id');
          } else {
            // filtered by category
            collection = Seriesdb.series
              .where('category_id')
              .equals(categoryId);
              console.log(collection);
              
          }
        
          const results = await collection
            .offset(offset)
            .limit(limit)
            .toArray();
        
          console.log(`Category '${categoryId}' → ${results.length} series`);
          return results;
        }

  //end dexieDB 

  public getSeriesCategories() {
    if(this.OToken){
      return this.http.get( this.getDataLcal() + `categories/series?token=${this.OToken}`)
    }else{
    const reqType = this.getRequestType()
    
    if(reqType == 'post'){
      return this.postAPIService.postApi('get_series_categories');
      }else if(reqType == 'get'){
      return this.http.get( this.getDataLcal() + 'get_series_categories');
      }
    }
  }


  public selectedCategoryWiseSeriesList(id: any) {
    if(this.OToken){
      return this.http.get( this.getDataLcal() + `content/series?token=${this.OToken}&category_id=${id}`)
    }else{
      const reqType = this.getRequestType()
      if(reqType == 'post'){
        return this.postAPIService.postApi('get_series', { category_id: id });
        }else if(reqType == 'get'){
        return this.http.get(this.getDataLcal() + 'get_series&category_id=' + id);
        }
    }
  }


  public selectedCategoryWiseSeriesLists(){
    if(this.OToken ){
      return this.http.get( this.getDataLcal() + `content/series?token=${this.OToken}&category_id=all`)
    }else{
      const reqType = this.getRequestType()
      if(reqType == 'post'){
        return this.postAPIService.postApi('get_series');
        }else if(reqType == 'get'){
        return this.http.get(this.getDataLcal() + 'get_series');
        }
    }
  }
  public getSeriesList() {
    if(this.OToken ){
      return this.http.get( this.getDataLcal() + `content/series?token=${this.OToken}&category_id=all`)
    }else{
      const reqType = this.getRequestType()
      if(reqType == 'post'){
        return this.postAPIService.postApi('get_series');
        }else if(reqType == 'get'){
        return this.http.get(this.getDataLcal() + 'get_series');
        }
    }
  }
  public getSeriesDetail(id: any) {
    localStorage.setItem('previousPage', window.location.href);
    if(this.OToken){
      return this.http.get( this.getDataLcal() + `content/series/${id}?token=${this.OToken}`)
    }
    else
    {
      const reqType = this.getRequestType()
      if(reqType == 'post'){
        return this.postAPIService.postApi('get_series_info',{series_id:id});
        }else if(reqType == 'get'){
        // return this.http.get(this.getDataLcal() + 'get_series');
        return this.http.get( this.getDataLcal() + 'get_series_info&series_id=' + id);
        }
    }
  }
  public getStreamSeriesUrl(id: any, ext: any) {
    this.getDataLcal();
    return (  this.domain + '/series/' + this.username + '/' + this.password + '/' + id + '.' + ext).replace(environment.cdnurl,'');
  }
  
}

export {Series}